export default __webpack_public_path__ + "static/media/001_background.c4b76f04.gif";